module.exports = __webpack_public_path__ + "static/media/temp_w_domu_ok_2.29a2fb87.svg";